module.exports = __webpack_public_path__ + "img/banner_zenfone10.692ffab5.jpg";